document.addEventListener('DOMContentLoaded', function () {
  const collectionSections = document.querySelectorAll('.sec__collection-overview');

  function setBlockOpen(block, isOpen) {
    const content = block.querySelector('.collapsible-content');
    const mobileImage = block.querySelector('.mobile-block-image');

    block.classList.toggle('is-open', isOpen);
    block.classList.toggle('active', isOpen);
    block.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (content) {
      content.classList.toggle('is-open', isOpen);
      content.style.display = isOpen ? 'block' : 'none';
    }

    if (mobileImage) {
      mobileImage.classList.toggle('is-open', isOpen);
      mobileImage.style.display = isOpen ? 'block' : 'none';
    }
  }

  function setActiveBanner(section, index) {
    const banners = section.querySelectorAll('.banner__media-collection');
    banners.forEach((banner) => {
      const isMatch = banner.getAttribute('data-index') === String(index);
      banner.classList.toggle('active', isMatch);
    });
  }

  collectionSections.forEach((section) => {
    const blocks = section.querySelectorAll('collapsible-block');

    if (blocks.length === 0) return;

    blocks.forEach((block, index) => {
      setBlockOpen(block, index === 0);
    });
    setActiveBanner(section, 1);

    blocks.forEach((block) => {
      const heading = block.querySelector('.collapsible-heading');
      if (!heading || heading.dataset.overviewBound === 'true') return;
      heading.dataset.overviewBound = 'true';

      heading.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          const blockIndex = block.getAttribute('data-index');
          const isCurrentlyOpen = block.classList.contains('is-open');

          if (isCurrentlyOpen) {
            setBlockOpen(block, false);
            return;
          }

          blocks.forEach((otherBlock) => {
            setBlockOpen(otherBlock, false);
          });

          setBlockOpen(block, true);
          setActiveBanner(section, blockIndex);

          if (window.innerWidth <= 768) {
            setTimeout(function () {
              block.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        },
        true
      );

      heading.addEventListener(
        'touchstart',
        function () {
          heading.classList.add('touch-active');
        },
        { passive: true }
      );

      heading.addEventListener(
        'touchend',
        function () {
          heading.classList.remove('touch-active');
        },
        { passive: true }
      );
    });
  });
});
